import clsx from 'clsx';
import {ReactNode} from 'react';
import CheckIcon from '@/icons/CheckIcon';
import styles from './styles.module.scss';

interface IResponseMessageProps {
    message?: ReactNode | null;
    messageStyles?: string[];
}

const ResponseMessage = ({message = null, messageStyles = []}: IResponseMessageProps) => {
    return (
        <div className={styles.response}>
            <CheckIcon width={66} height={66} />
            {!!message && <div className={clsx(styles.message, ...messageStyles)}>{message}</div>}
        </div>
    );
};

export default ResponseMessage;
